import type { EventStatus } from './event';
import type { LegalType } from './blogger';

export interface BankDetailsBase {
  beneficiaryId: string;
  bankDetailsId: string;
  type: string;
  isDefault: boolean;
}

export interface BankDetails extends BankDetailsBase {
  bik: string;
  kpp: string;
  inn: string;
  name: string;
  bankName: string;
  accountNumber: string;
  corrAccountNumber: string;
  type: 'SBP' | 'PAYMENT_DETAILS';
  phoneNumber: string;
  bankId: string;
  legalType: LegalType;
}

export interface BeneficiaryInfo {
  status: BeneficiaryStatus;
  id: string;
  inn: string;
  fullOpf: string;
  legalType: LegalType;
  birthDate: string;
  birthPlace: string;
  citizenship: string;
  documents: any;
  addresses: string;
  snils: string;
  signSmartId?: string;
  registrationDate: '2017-09-28';
  orgrn: string;
  kio: string;
  opf: string;
}

export enum BeneficiaryStatus {
  IN_PROGRESS,
  FAILED,
  SUCCEEDED,
  FAILED_INN,
  SUCCEEDED_INN,
  NEW,
}

export interface IPayment {
  id: number;
  date: string;
  amount: number;
  paid: PaymentStatus;
  bankDetailsId: string | null;
  bloggerEventId: string;
  transferType: TransferType;
  moneyStatus: MoneyStatus;
}

export enum TransferType {
  incoming,
  outgoing,
  freez,
  bloggerEventBonus,
  parsing,
  comission,
  unFreez,
  bloggerEventFix,
}

export enum PaymentStatus {
  /// Менеджер отпарвил на переделывание.
  ManagerSendForFix,
  /// Ожидает обработки.
  ManagerCheck,
  /// Ожидает обработки.
  ManagerApprove,
  /// Ожидает обработки.
  PENDING,
  /// В процессе.
  IN_PROGRESS,
  /// Неуспешен.
  FAILED,
  /// Отменен.
  CANCELLED,
  /// Успешно завершен.
  SUCCEEDED,
}

export enum MoneyStatus {
  /// Деньги в пути — начислены, но ещё нельзя вывести (ожидается подписание актов)
  InTransit,
  /// Ожидает запроса на вывод (только для самозанятых)
  AwaitingPayoutRequest,
  /// Чек на проверке (для самозанятых)
  AwaitingReceiptCheck,
  /// В обработке — отправлено на проверку или проверяется
  Processing,
  /// Принят на исполнение банком
  AcceptedByBank,
  /// Выплата успешно завершена
  Succeeded,
  /// Ошибка обработки — требуются уточнения
  Failed,
  /// Отклонено (на любом этапе)
  Rejected,
  /// Оспаривание / спорный момент
  Disputing,
  /// Оспаривание подтверждено
  DisputeApproved,
  /// Оспаривание отклонено
  DisputeRejected,
  /// Выплата отменена вручную
  Cancelled,
}

export interface IOrder {
  bloggerEventId: string;
  eventId: string;
  eventName: string;
  status: EventStatus;
  reward: unknown;
  createdAt: string;
  transfers: ITransfer[];
  totalSucceeded: number;
  totalInTransit: number;
  isCompleted: boolean;
}

export interface ITransfer {
  id: string;
  amount: number;
  moneyStatus: MoneyStatus;
  transferType: TransferType;
  fromBeneficiaryId: string;
  toBeneficiaryId: string;
  createdAt: string;
}

export interface IAct extends IReceipt {
  id: number;
  clientId: number;
  bloggerId: number;
  eventName: string;
  status: ActSignStatus;
  createdAt: string;
  signedByBloggerAt: string;
  signedByClientAt: string;
  completedAt: string;
  signingDeadlineAt: string;
  bloggerEventId: string;
  totalToBloggerSucceeded: number;
  totalToBloggerInTransit: number;
  totalAllTransfers: number;
  transfers: ITransfer[];
  comment: string;
  isNeedReceipt: boolean;
}

export enum ActSignStatus {
  Draft = 0, // черновик, ещё ничего не отправляли
  InProgress = 1, // есть хотя бы один Waiting
  Completed = 2, // все обязательные роли подписали
  RejectClient = 3,
  RejectBlogger = 4,
  RejectPlatform = 5,
  Cancelled = 6,
  Error = 7,
  Expired = 8,
}

export enum SignCheckStatus {
  NotSigned = 0,
  Signed = 1,
  Rejected = 2,
  Deleted = 3,
}

export interface IReceipt {
  receiptLink: string;
  receiptFileLink: string;
}
